"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _construct2 = _interopRequireDefault(require("@babel/runtime/helpers/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _sync = _interopRequireDefault(require("./sync.ddos"));

/**
 * Подписка стореджа на асинхронное событие
 * данные для события могут прийти в любой момент в socket
 * либо обновися при опросе альтернативного URL (ddos)
 */
var _default =
/*#__PURE__*/
function () {
  function _default() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2["default"])(this, _default);
    this.syncDDOS = _sync["default"].getInstance(options.syncDDOS);
    return this;
  }

  (0, _createClass2["default"])(_default, [{
    key: "query",
    value: function query() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var method = arguments.length > 1 ? arguments[1] : undefined;
      var storage = arguments.length > 2 ? arguments[2] : undefined;
      // TODO add websocket sync as alternate
      this.syncDDOS.query(options, method, storage);
      return this;
    }
    /**
     * stop listening storage
     * @param {object} storage
     * @return {object}
     */

  }, {
    key: "stopListening",
    value: function stopListening(storage) {
      if (storage) {
        this.syncDDOS.stopListening(storage);
        delete storage._syncListenerId;
      }

      return this;
    }
    /**
     * @return {object} singleton of this class
     */

  }], [{
    key: "getInstance",
    value: function getInstance() {
      if (!this.prototype.singletonInstance) {
        var parent = this,
            Surrogate;

        Surrogate = function Surrogate() {
          var _parent$prototype$con;

          for (var _len2 = arguments.length, rest = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            rest[_key2] = arguments[_key2];
          }

          // для того что бы принимать динамическое к-во аргументов в конструктор
          return (_parent$prototype$con = parent.prototype.constructor).call.apply(_parent$prototype$con, [this].concat(rest));
        };

        Surrogate.prototype = parent.prototype;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        this.prototype.singletonInstance = (0, _construct2["default"])(Surrogate, args);
      }

      return this.prototype.singletonInstance;
    }
  }]);
  return _default;
}();

exports["default"] = _default;